export default __webpack_public_path__ + "static/media/step-2-home-mobile.f36d4280.png";